import React from 'react';

import Header from '../components/Header';
import Footer from '../components/Footer';
import teamMembers from '../data/teamMembers';

import { nationalStructure } from '../data/nationalStructure';

const getDivisionForRole = (role) => {
  for (const [division, data] of Object.entries(nationalStructure)) {
    if (data.roles.some(r => r.role === role)) return division;
  }
  console.warn('No division found for role:', role);
  return 'Other';
};

const getDivisionDescription = (divisionName) => {
  const description = nationalStructure[divisionName]?.description;
  if (!description) console.warn('No description found for division:', divisionName);
  return description || '';
};

const Leadership = () => {
  const teamWithDivision = teamMembers.map(member => {
    const division = member.function || getDivisionForRole(member.role);
    return { ...member, division };
  });

  const divisions = teamWithDivision.reduce((acc, member) => {
    const division = member.division;
    if (!acc[division]) acc[division] = [];
    acc[division].push(member);
    return acc;
  }, {});

  return (
    <div style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh' }}>
    <Header/>
    <main style={{ padding: '6rem 2rem 3rem', maxWidth: '700px', margin: '0 auto' }}>
      {Object.entries(divisions).map(([division, members]) => (
        <div key={division} style={{ marginBottom: '3rem' }}>
          <h2 className="huge-title">{division}</h2>
          <p className="subtitle">{getDivisionDescription(division)}</p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: '1.5rem',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            {members.map((member, idx) => (
              <div key={idx} style={{ textAlign: 'center' }}>
                <img
                  src={member.image || '/default-avatar.png'}
                  alt={member.name}
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '2px solid #DC66FF',
                    marginBottom: '0.5rem',
                    backgroundColor: '#ffffff',
                  }}
                />
                <p style={{ fontWeight: 600, fontSize: '1rem', color: '#fff', marginBottom: '0.25rem' }}>{member.name}</p>
                <p className="big-content-text" style={{ marginBottom: '0.25rem' }}>{member.role}</p>
                {member.linkedin && (
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-text"
                    style={{
                      fontSize: '0.7rem',
                      display: 'inline-block',
                    }}
                  >
                    LinkedIn ↗
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </main>
    <Footer/>
    </div>
  );
};

export default Leadership;